import { useNavigate } from 'react-router-dom';

const colors = {
  navy: '#071a52',
  textPrimary: '#1a1a2e',
  border: '#e2e4e8',
  cardBg: '#ffffff',
};

function PageHeader({ title, icon }) {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '24px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{ fontSize: '1.3rem', color: colors.navy }}>{icon}</span>
        <span style={{
          fontSize: '1.4rem',
          fontWeight: 800,
          color: colors.textPrimary,
        }}>{title}</span>
      </div>
      <button
        onClick={() => navigate('/')}
        style={{
          padding: '8px 16px',
          background: colors.cardBg,
          border: `1px solid ${colors.border}`,
          borderRadius: '6px',
          color: colors.navy,
          fontFamily: "'Outfit', sans-serif",
          fontWeight: 600,
          fontSize: '0.85rem',
          cursor: 'pointer',
        }}
      >
        ← Home
      </button>
    </div>
  );
}

export default PageHeader;